export const acceptCookiesParamName = 'orderGUID';
export const transferParamName = 'transferCode';

export const uiMessagesAcceptCookiesParamName = 'qrToken';
export const uiMessagesTransferParamName = 'qrTransferToken';
